const enNames = {
    'names.people.first': 'Jack|Billy|Nora|Ivy|Hank|Mila|Owen|Lily|Finn|Tess|Gus|Mara',
    'names.people.last': 'Strong|White|Stone|Hill|River|Black|Bright|Hawk|Moss|Reed|Fox|Hart',
    'names.settlement.adjectives':
        'Amber|Iron|Stone|Silver|Golden|Frost|Raven|Shadow|Sapphire|Pearl|Wolf|Dragon|Eagle|Oak|Quiet|Flame|Night|White|Black|Green|Moon|Star|Steel|Misty|Storm|Ashen|Sun|Coral|Granite|Winter',
    'names.settlement.nouns':
        'Shore|Hold|Bridge|Harbor|Road|Guard|Bastion|Grove|Bay|Fortress|Gorge|Gate|Peak|Manor|Port|Castle|Tower|Vale|Stone|Trail|Spring|Market|Postern|Wall|Rampart|Fort|Watch|Ford|Pass|Keep',
};

export default enNames;
